// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import Dropdown, { type DropdownItem } from 'common/components/ui/Dropdown';
import LabeledInput from 'statsradio/components/ui/forms/LabeledInput';
import { Interval, type StepInMinutes } from 'statsradio/domain/reach';

const Wrapper = styled.div`
  width: 180px;
`;

interface Props {
  timeInterval: Interval;
  onChange: (timeInterval: Interval) => void;

  t: any;
}

export function TimeIntervalPicker({ timeInterval, onChange, t }: Props) {
  const intervals: DropdownItem<StepInMinutes>[] = [
    { value: 5, label: t('time.nbMinute', { count: 5 }) },
    { value: 15, label: t('time.nbMinute', { count: 15 }) },
    { value: 30, label: t('time.nbMinute', { count: 30 }) },
    { value: 60, label: t('time.nbHour', { count: 1 }) },
  ];

  function onDropdownChange(step: StepInMinutes) {
    const newInterval = new Interval({ ...timeInterval, step });
    onChange(newInterval);
  }


  return (
    <Wrapper>
      <LabeledInput label={t('interval')} name="interval">
        <Dropdown
          name="interval"
          defaultValue={timeInterval.step}
          items={intervals}
          onChange={onDropdownChange}
        />
      </LabeledInput>
    </Wrapper>
  );
}

export default translate('metrics')(TimeIntervalPicker);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/TimeIntervalPicker.js